import { render, staticRenderFns } from "./KioskView.vue?vue&type=template&id=240b8e4c&"
import script from "./KioskView.vue?vue&type=script&lang=js&"
export * from "./KioskView.vue?vue&type=script&lang=js&"
import style0 from "./KioskView.vue?vue&type=style&index=0&id=240b8e4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports